import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchAuthSession, signOut as authSignOut } from 'aws-amplify/auth';
import { useSelector } from 'react-redux';
import { authActions } from 'redux/auth';
import { Store, store } from 'redux/store';
import SignIn from './SignIn';
import LayoutContainer from 'pages/LayoutContainer';
import { AuthStatus } from 'models/auth';
import RequireNewPassword from './RequireNewPassword';
import ForgotPassword from './ForgotPassword';
import Loading from 'pages/LayoutContainer/Loading';

const Authenticator: React.FC = () => {
  const navigate = useNavigate();
  const { isLogin, needLogoutFlags, isNewPasswordRequired, isForgetPassword } =
    useSelector((store: Store) => store.auth);

  const [authStatus, setAuthStatus] = useState<AuthStatus>(AuthStatus.pending);

  useEffect(() => {
    if (isForgetPassword) {
      setAuthStatus(AuthStatus.forgetPassword);
    } else if (isNewPasswordRequired) {
      setAuthStatus(AuthStatus.newPasswordRequired);
    } else {
      // 画面リロード時のセッション状態を確認
      fetchAuthSession()
        .then(() => {
          store.dispatch(authActions.login());
        })
        .catch(error => {
          console.log('Session = ', error);
          setAuthStatus(AuthStatus.unauthenticated);
        });
    }
  }, [isForgetPassword, isNewPasswordRequired]);

  useEffect(() => {
    const signOut = () => {
      authSignOut()
        .then(() => {
          setAuthStatus(AuthStatus.unauthenticated);
        })
        .catch(error => {
          console.log('Error = ', error);
        });
    };
    if (isLogin) {
      setAuthStatus(AuthStatus.authenticated);
    }
    if (needLogoutFlags.isLogout) {
      if (needLogoutFlags.isMoveToRoot) {
        navigate('/');
      }

      signOut();
    }
  }, [isLogin, navigate, needLogoutFlags]);

  switch (authStatus) {
    case AuthStatus.authenticated:
      return <LayoutContainer />;
    case AuthStatus.unauthenticated:
      return <SignIn />;
    case AuthStatus.newPasswordRequired:
      return <RequireNewPassword />;
    case AuthStatus.forgetPassword:
      return <ForgotPassword />;
    default:
      return <Loading />;
  }
};

export default Authenticator;
